// Freed by the `feedback/client.ts` port and moved with it: with the client in
// `/data` the hook's whole graph is a mutation over one POST, so it is a
// headless data-layer hook and belongs here rather than in `/ui`. It sits in
// `data/voice/` with its client rather than in `data/mutation/` for the reason
// `data/routines/` exists — the voice slice is read as a slice.
//
// The `no-new-carved-domain-data` suppression the app path carried is gone with
// the app path: that rule scopes `src/**`.
import { useMutation } from '@tanstack/react-query';

import type { SubmitVoiceFeedbackRequest } from '../../contracts/voice-feedback.types';

import { voiceFeedbackClient } from './voiceFeedbackClient';

export const useSubmitVoiceFeedback = () => {
  return useMutation({
    mutationFn: async (body: SubmitVoiceFeedbackRequest) =>
      (await voiceFeedbackClient.submitFeedback(body)).data,
  });
};
